import { useMemo, useEffect } from 'react';
import { useValidate } from '../useValidate';
import { campaignJsonSchema } from '../../zod/campaignJsonSchema';
import { doesPageMatch, doesScheduleMatch, doesDeviceMatch, doesDimensionsMatch, } from './matchingFunctions';
export function useCampaignsFiltration(_a) {
    var jsonCampaigns = _a.jsonCampaigns, error = _a.error, isFetching = _a.isFetching, log = _a.log;
    useEffect(function () {
        log({
            isLoading: isFetching,
            error: error,
        });
    }, [isFetching, error]);
    var validCampaigns = useValidate(jsonCampaigns, campaignJsonSchema, log).valid;
    var filteredCampaigns = useMemo(function () {
        return validCampaigns
            .filter(doesPageMatch)
            .filter(doesScheduleMatch)
            .filter(doesDeviceMatch)
            .filter(function (item) { return doesDimensionsMatch(item); });
    }, [validCampaigns]);
    useEffect(function () {
        var isValid = validCampaigns.length;
        var isFilteredExist = filteredCampaigns.length;
        if (isValid && !isFilteredExist) {
            log({
                reason: 'No matching campaigns.',
                recieved_campaigns: jsonCampaigns,
                valid_campaigns: validCampaigns,
                filtered_campaigns: filteredCampaigns,
            });
        }
    }, [filteredCampaigns, validCampaigns]);
    var result = useMemo(function () { return ({
        campaignIdCorrelationInfo: filteredCampaigns.map(function (c) { return ({
            campaignId: c.campaignId,
            correlationId: c.correlationId,
        }); }),
        error: error,
        isLoading: isFetching,
    }); }, [filteredCampaigns, error]);
    return result;
}
